import React from "react";
import PageHeader from "../../components/PageHeader";
import CouponCreateComponent from "../../components/Coupon/CouponCreate";

class CouponCreate extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Coupon Create"
                            Breadcrumb={[
                                { name: "Coupons", navigate: "/coupons" },
                                { name: "Coupon Create", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <CouponCreateComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CouponCreate;
